var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10, _radialGradient11, _radialGradient12, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _radialGradient17, _radialGradient18, _radialGradient19, _radialGradient20, _radialGradient21, _radialGradient22, _radialGradient23, _radialGradient24, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIrelandDailyMillionAfternoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 42.252,
    cy: 12.873,
    r: 6.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    stopColor: "#fffdf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#fff8e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#ffefc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ffe498"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#ffd45f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#ffc21a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#fdbc1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#f6ac26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#f5aa27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#efa627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e09c27"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 29.498,
    cy: 5.608,
    r: 4.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.088,
    stopColor: "#f0fafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    stopColor: "#c9ecf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#8bd6e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#78cfdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#50b0c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#339bba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2993b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#238daf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#147d9e"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 16.423,
    cy: 7.096,
    r: 4.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.088,
    stopColor: "#f0fafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    stopColor: "#c9ecf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#8bd6e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#78cfdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#50b0c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#339bba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2993b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#238daf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#147d9e"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 7.814,
    cy: 14.343,
    r: 4.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.088,
    stopColor: "#f0fafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    stopColor: "#c9ecf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#8bd6e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#78cfdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#50b0c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#339bba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2993b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#238daf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#147d9e"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 3.625,
    cy: 23.944,
    r: 3.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.088,
    stopColor: "#f0fafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    stopColor: "#c9ecf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#8bd6e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#78cfdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#50b0c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#339bba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2993b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#238daf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#147d9e"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 18.057,
    cy: 27.547,
    r: 14.112,
    gradientTransform: "matrix(.9502 -.3115 .1377 .4202 -2.896 21.598)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#cfd30c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopColor: "#c3ce0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#a2c112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 19.266,
    cy: 26.652,
    r: 8.19,
    gradientTransform: "matrix(.6867 -.727 .3563 .3366 -3.46 31.688)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#f8e954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#e5df32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#d5d616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#cfd30c"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 40.167,
    cy: 28.963,
    r: 7.728,
    gradientTransform: "matrix(.9681 -.2506 .0991 .3828 -1.588 27.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#b6c90a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#aac40e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 31.059,
    cy: 25.642,
    r: 5.488,
    gradientTransform: "matrix(.7514 .6599 -.2395 .2727 13.862 -1.845)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#a6cc05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#a0c210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 38.198,
    cy: 51.086,
    r: 0.967,
    gradientTransform: "matrix(.9649 -.2627 1.2057 4.4285 -60.254 -165.114)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#72a61d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 40.003,
    cy: 46.842,
    r: 1.91,
    gradientTransform: "matrix(.9767 -.2145 .6725 3.0631 -30.572 -88.061)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#86b41b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 26.799,
    cy: 49.992,
    r: 11.69,
    gradientTransform: "matrix(.9569 .2906 -.1117 .3677 6.739 23.822)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#88b41a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#94ba16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 11.093,
    cy: 45.639,
    r: 8.864,
    gradientTransform: "matrix(.7543 -.6566 .2967 .3409 -10.816 37.367)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#86b51c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#92ba17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 12.258,
    cy: 44.693,
    r: 5.626,
    gradientTransform: "matrix(.7286 -.6849 .1703 .1811 -4.282 44.994)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#94bb1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#88b61c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#86b51c"
  }))), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 23.312,
    cy: 51.171,
    r: 17.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#9fc012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#2e6213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#3a6c13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#5b8713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    stopColor: "#90b312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 41.122,
    cy: 39.704,
    r: 4.112,
    fx: 40.478,
    fy: 39.66,
    gradientTransform: "matrix(.9639 .2662 -1.6172 5.8566 65.693 -203.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#5c9136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#689a2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#89b01e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 33.846,
    cy: 26.73,
    r: 14.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#82b11f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#8eb719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 23.192,
    cy: 31.342,
    r: 7.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#bcca1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#9eb421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#73962a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#8aac1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#9abb15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient19 || (_radialGradient19 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: 31.347,
    cy: 30.722,
    r: 6.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcca1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#9eb421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#73962a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#8aac1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#9abb15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient20 || (_radialGradient20 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: 23.261,
    cy: 34.921,
    r: 1.104,
    gradientTransform: "matrix(.9923 -.124 .4301 3.4431 -14.841 -82.433)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#626f54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5d6952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#4e594c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#4b554b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#484f46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#3f3f37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.978,
    stopColor: "#3e3c35"
  }))), _radialGradient21 || (_radialGradient21 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: 28.58,
    cy: 43.799,
    r: 6.315,
    gradientTransform: "matrix(1 0 0 .412 0 25.752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#669b1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#477614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b6811"
  }))), _radialGradient22 || (_radialGradient22 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: 22.556,
    cy: 31.39,
    r: 1.04,
    gradientTransform: "matrix(.9183 -.3958 .4818 1.1179 -13.281 5.228)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#e6e8e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#d2d6ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#b8beb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#99a18f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#747f67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#626f54"
  }))), _radialGradient23 || (_radialGradient23 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: 31.103,
    cy: 34.277,
    r: 1.026,
    gradientTransform: "matrix(.9907 -.1362 .5259 3.8247 -17.736 -92.585)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#626f54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5d6952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#4e594c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#4b554b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#484f46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#3f3f37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.978,
    stopColor: "#3e3c35"
  }))), _radialGradient24 || (_radialGradient24 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: 30.53,
    cy: 30.966,
    r: 0.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#e6e8e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#d2d6ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#b8beb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#99a18f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#747f67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#626f54"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.97 17.005c5.248 0 9.508 4.212 9.508 9.411s-4.26 9.411-9.508 9.411c-5.264 0-9.525-4.212-9.525-9.411.016-5.183 4.276-9.411 9.525-9.411z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.75 6.282c3.952 0 7.16 3.175 7.16 7.079s-3.207 7.079-7.16 7.079-7.16-3.175-7.16-7.079 3.207-7.079 7.16-7.079z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.774 9.473c3.515 0 6.366 2.819 6.366 6.301s-2.851 6.301-6.366 6.301-6.366-2.819-6.366-6.301c-.016-3.483 2.851-6.301 6.366-6.301z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.454 22.237c3.045 0 5.507 2.446 5.507 5.443 0 3.013-2.462 5.459-5.507 5.459s-5.507-2.446-5.507-5.459c0-2.997 2.462-5.443 5.507-5.443z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.845 37.885c2.576 0 4.665 2.073 4.665 4.617s-2.09 4.617-4.665 4.617-4.681-2.073-4.681-4.617c.016-2.543 2.106-4.617 4.681-4.617z",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m10.201 56.108 24.946-6.01s2.689-2.754 4.438-9.687c1.749-6.917 1.636-9.314 1.636-9.314s.697-.535 1.118-.162a10126.811 10126.811 0 0 1 16.069 15.048l27.278-.535s.259.421.049 1.231c-.211.794-2.219 5.912-6.398 10.95-4.179 5.054-8.034 8.618-8.034 8.618s-.745.421-.697 1.539.162 1.863 1.004 5.264 1.118 8.828.47 11.857l-2.171 8.618s-.583-.162-1.166-.745-6.496-5.475-10.675-8.569c-4.179-3.078-9.152-6.172-9.784-6.334s-7.872 1.49-10.092 2.187-8.148 1.069-11.841 1.231h-8.196s-.486-.632.146-1.069c.632-.421 4.131-5.102 6.026-8.034s3.013-4.795 2.916-5.426c-.113-.632-3.904-3.515-8.877-5.896-4.941-2.365-9.006-4.114-8.164-4.762z",
    fill: "#9fc012"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.38 56.756s7.613 2.981 20.507 2.073 17.77-7.451 17.867-12.667C52.867 40.946 42.128 31 41.917 32.701s-2.689 15.469-6.382 17.802c-3.677 2.333-24.962 4.6-21.155 6.253z",
    fill: "url(#f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.524 53.208s8.148-.875 11.112-2.786 5.135-10.48 5.394-12.457c.259-1.96 3.645-1.328 2.964 5.848s-4.001 8.861-9.913 9.557c-5.929.697-9.33.535-9.557-.162z",
    fill: "url(#g)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84 47.361s.47.713-7.953 4.973c-8.439 4.244-11.08 2.851-12.214 2.397s-5.653-3.645-2.543-5.556c3.126-1.911 22.969-3.677 22.71-1.814z",
    fill: "url(#h)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.763 50.536 50.194 39.31c-.47-1.199 8.067 8.488 8.488 8.083.421-.389 4.131-1.296 3.596-.34s-1.798 1.247-2.543 2.446c-.729 1.199-.794 1.409-.972 1.037z",
    fill: "url(#i)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.94 93.559s-1.879-6.074-4.341-10.902c-1.458-2.867 2.657-4.325 3.807 1.069.81 3.774.551 6.301.551 8.326l-.016 1.506z",
    fill: "url(#j)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.734 87.338s-.049-5.864-1.798-10.74c-1.749-4.892-1.263-7.241-.211-6.658s3.045 4.017 3.126 9.946c.065 5.929-.859 8.245-1.118 7.451z",
    fill: "url(#k)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m66.134 88.942-12.586-9.249c-4.228-2.559-5.135-2.657-6.398-2.397s-11.096 1.701-12.959 1.976c-1.847.275-3.385.162-3.385.162l13.963-3.094c5.135-.907 13.38 1.863 16.279 4.309 2.916 2.43 5.362 6.107 5.086 8.294z",
    fill: "url(#l)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.695 65.001s9.751 3.726 8.909 7.403c-.842 3.661-6.139 7.727-9.573 8.472s-8.423.518-7.581-.389 8.504-10.529 8.456-12.602c-.049-2.09-2.268-3.304-.211-2.883z",
    fill: "url(#m)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.45 80.47s8.618-7.451 9.249-10.156 5.977-1.28 3.693 2.122c-2.268 3.402-7.646 7.694-10.14 8.31s-4.082.567-3.709.308l.907-.583z",
    fill: "url(#n)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.085 60.271a23.552 23.552 0 0 1 4.422 1.263c6.82 2.657 8.877 4.357 7.775 6.803-1.118 2.446-5.524 9.12-8.18 11.29-.745.599-1.798 1.15-2.964 1.604-.113-.194-.275-.648.211-.972.632-.421 4.131-5.102 6.026-8.034s3.013-4.795 2.916-5.426c-.113-.632-3.904-3.515-8.877-5.896l-1.328-.632z",
    fill: "#81b31d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.186 81.329s6.56-.065 13.85-1.004c7.305-.956 14.546-2.981 17.025-2.608 2.495.373 10.837 6.496 13.85 9.152 2.592 2.3 5.702 4.779 7.046 6.674 0 .016-.016.016-.016.032-.324.421-.583-.162-1.166-.745s-6.496-5.475-10.675-8.569c-4.179-3.078-9.152-6.172-9.784-6.334s-7.872 1.49-10.092 2.187-8.148 1.069-11.841 1.231c-3.709.146-8.196-.016-8.196-.016z",
    fill: "url(#o)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M72.014 85.378c.146-2.721.162-5.767-.292-7.824l-2.09-10.464c-.097-1.166 1.053-1.749 3.596-4.147s8.634-9.751 10.318-12.311a40.693 40.693 0 0 0 2.057-3.499c-.567 1.555-2.576 6.042-6.236 10.497-4.179 5.054-8.034 8.618-8.034 8.618s-.745.421-.697 1.539.162 1.863 1.004 5.264 1.118 8.828.47 11.857l-.097.47z",
    fill: "url(#p)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M85.701 45.482s-12.813 1.263-17.899 1.182c-5.07-.081-8.65 0-8.65 0s-.016 1.037-.778.616S43.86 33.139 43.471 32.021l14.935 13.995 27.294-.535z",
    fill: "url(#q)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40.605 35.973c.032.859-.032 1.992-.292 3.499-.923 5.394-2.657 9.946-5.475 11.112-2.365.988-8.115 2.397-10.837 2.203l11.161-2.689s2.689-2.754 4.438-9.687l1.004-4.438z",
    fill: "#a0b936"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M41.966 51.184s-1.523.907-1.555 2.754c-.016 1.83.194 4.017.875 7.322s1.766 4.843 3.758 4.325c1.976-.518 1.863-3.596 1.587-8.115-.259-4.519-2.576-6.998-4.665-6.285z",
    fill: "url(#r)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M54.746 50.325s-1.458.632-1.49 2.478.632 4.519 1.069 7.694 1.539 4.86 3.547 4.325 1.879-3.628 1.62-8.18c-.275-4.552-2.64-7.046-4.746-6.317z",
    fill: "url(#s)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M42.484 52.771s-.648.373-.616 2.025.373 4.26.648 7.046 1.182 4.325 2.527 3.855 1.15-3.24.826-7.289-1.976-6.285-3.385-5.637z",
    fill: "url(#t)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M39.876 69.018s.713-.292 1.053-.162 4.26 1.62 10.173 1.668c5.929.049 9.784-.778 10.464-.988s1.474.032 1.425.194-.324.097-1.571.826c-1.231.713-3.807 3.612-9.33 3.483s-7.532-2.057-9.249-3.094-1.879-1.328-2.592-1.49c-.697-.146-.373-.437-.373-.437z",
    fill: "url(#u)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M43.132 52.803c.697 0 1.247.664 1.247 1.49s-.551 1.49-1.247 1.49c-.68 0-1.231-.664-1.231-1.49-.016-.826.535-1.49 1.231-1.49z",
    fill: "url(#v)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M55.281 51.864s-.648.373-.616 2.025.373 4.26.648 7.046 1.182 4.341 2.527 3.855c1.344-.47 1.166-3.24.842-7.289-.34-4.05-1.992-6.285-3.402-5.637z",
    fill: "url(#w)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M55.912 51.896c.697 0 1.247.664 1.247 1.49s-.551 1.49-1.247 1.49c-.68 0-1.231-.664-1.231-1.49 0-.81.551-1.49 1.231-1.49z",
    fill: "url(#x)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M45.643 70.767c2.122.405 6.188.891 11.922 0 1.895-.292 3.256-.405 4.228-.405.94-.518 1.166-.486 1.215-.632.049-.162-.745-.405-1.425-.194-.697.211-4.552 1.037-10.464.988s-9.832-1.539-10.173-1.668c-.34-.146-1.053.162-1.053.162s-.308.292.405.454.875.454 2.592 1.49c.972.583 2.025 1.442 3.758 2.106-1.555-1.247-2.657-2.624-1.004-2.3z",
    fill: "#3b6811"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M79.756 12.777c-.486 1.344-.664 2.43-.68 3.466a9.65 9.65 0 0 0-1.944-.194c.34-1.766 1.344-2.77 2.624-3.272zm.875 3.904c.923-1.555 2.203-2.154 3.58-2.171-.923 1.085-1.442 2.041-1.814 3.029a10.448 10.448 0 0 0-1.766-.859zm3.061 1.798c1.393-1.15 2.802-1.263 4.098-.81-1.231.713-2.057 1.442-2.738 2.219a9.33 9.33 0 0 0-1.361-1.409zm2.284 2.721c1.685-.599 3.061-.227 4.131.648-1.393.259-2.414.632-3.321 1.15a12.92 12.92 0 0 0-.81-1.798zm1.199 3.353c1.798.016 2.964.842 3.661 2.025-1.393-.243-2.495-.227-3.515-.065v-.194a10.675 10.675 0 0 0-.146-1.766zm-.016 3.58c1.685.632 2.495 1.814 2.754 3.159a10.529 10.529 0 0 0-3.272-1.28 10.383 10.383 0 0 0 .518-1.879zm-1.215 3.337c1.361 1.182 1.717 2.559 1.506 3.92-.923-1.101-1.766-1.782-2.657-2.316a9.365 9.365 0 0 0 1.15-1.604zm-2.284 2.721c.875 1.587.745 2.997.081 4.212-.486-1.344-1.053-2.284-1.701-3.094a9.262 9.262 0 0 0 1.62-1.118zm-3.061 1.782c.292 1.782-.324 3.078-1.344 3.969 0-1.425-.211-2.511-.551-3.499a8.54 8.54 0 0 0 1.895-.47zm-3.499.616c-.324 1.782-1.344 2.786-2.624 3.272.486-1.344.664-2.43.68-3.466a9.65 9.65 0 0 0 1.944.194zm-3.499-.616c-.907 1.555-2.203 2.154-3.58 2.171.907-1.101 1.442-2.057 1.814-3.029.567.34 1.166.632 1.766.859zm-3.045-1.798c-1.393 1.15-2.819 1.263-4.098.81 1.231-.713 2.057-1.442 2.738-2.219.389.518.859.988 1.361 1.409zm-2.284-2.738c-1.701.599-3.078.211-4.131-.648 1.393-.243 2.414-.632 3.321-1.15a9.994 9.994 0 0 0 .81 1.798zm-1.199-3.353c-1.798-.016-2.964-.842-3.661-2.025 1.393.243 2.495.227 3.515.065v.194a9.103 9.103 0 0 0 .146 1.766zm0-3.564c-1.685-.632-2.495-1.814-2.754-3.175a10.529 10.529 0 0 0 3.272 1.28 10.491 10.491 0 0 0-.518 1.895zm1.215-3.353c-1.361-1.182-1.717-2.559-1.506-3.92a10.3 10.3 0 0 0 2.64 2.333c-.421.486-.794 1.02-1.134 1.587zm2.284-2.721c-.875-1.571-.745-2.997-.081-4.212.486 1.344 1.053 2.284 1.701 3.094a10.27 10.27 0 0 0-1.62 1.118zm3.078-1.782c-.292-1.782.308-3.078 1.344-3.985 0 1.425.211 2.511.551 3.499a10.49 10.49 0 0 0-1.895.486z",
    fill: "#f0bb4f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrelandDailyMillionAfternoon);
export default __webpack_public_path__ + "static/media/ireland_daily_million_afternoon.1bd4779e60638d10f9d4594144e0e06a.svg";
export { ForwardRef as ReactComponent };